// extracted by mini-css-extract-plugin
module.exports = {"form":"PortalPasswordForm_form__xiXXc","error":"PortalPasswordForm_error__IuHSy","disclaimer":"PortalPasswordForm_disclaimer__vqNcQ","divider":"PortalPasswordForm_divider__Vx7m9"};